/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * One action in a `ptl-dropdown` panel. Projects its content (an icon and a label, a label and a pill), so the
 * row looks the same in every menu.
 *
 * `clicked` fires from the host so a test or caller clicking the element itself, not the inner button, still
 * triggers it; it hands over the event for callers that must stop it reaching a clickable row.
 */
@Component({
  selector: 'ptl-dropdown-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="dropdown-item"
      [class.dropdown-item--danger]="danger()"
      [disabled]="disabled()"
      [attr.role]="menuItem() ? 'menuitem' : null"
    >
      <ng-content></ng-content>
    </button>
  `,
  styleUrls: ['./ptl-dropdown-item.component.scss'],
  host: {
    '(click)': 'onClick($event)',
  },
})
export class PtlDropdownItemComponent {
  danger = input(false);
  disabled = input(false);
  /** For a panel marked up as `role="menu"`. */
  menuItem = input(false);
  clicked = output<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (this.disabled()) {
      return;
    }
    this.clicked.emit(event);
  }
}
